<template>
  <el-dialog
    :visible.sync="showPopup"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    custom-class="ovd-dialog"
    width="460px">
    <div class="ovd-head">
      <div class="ovd-icon">
        <i class="el-icon-warning-outline" />
      </div>
      <h3 class="ovd-title">Thông báo ngừng giao diện cũ</h3>
    </div>

    <p class="ovd-text">
      Giao diện cũ của <strong>Salework Zalo</strong> sẽ ngừng hoạt động. Toàn bộ tính năng được chuyển sang giao diện mới.
    </p>

    <div class="ovd-deadline">
      <i class="el-icon-time" />
      <span>Ngừng hoạt động từ <strong>{{ SHUTDOWN_DATE }}</strong></span>
    </div>

    <p class="ovd-note">Bạn có thể chuyển ngay bây giờ, dữ liệu hội thoại và thẻ được giữ nguyên.</p>

    <div class="ovd-footer">
      <el-checkbox v-model="invisible">Không hiển thị lại</el-checkbox>
      <div class="ovd-actions">
        <el-button
          size="small"
          plain
          @click="closePopup()">
          Để sau
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="switchToNew()">
          Chuyển sang giao diện mới
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { NEW_VERSION_URL, SHUTDOWN_DATE } from "@/lib/old-version-notice";

const HIDDEN_KEY = "OldVersionDialog";

export default {
  name: "OldVersionDialog",
  data() {
    return {
      showPopup: true,
      invisible: false,
      SHUTDOWN_DATE
    };
  },
  methods: {
    closePopup() {
      if (this.invisible) {
        localStorage.setItem(HIDDEN_KEY, "hidden");
      }
      this.showPopup = false;
    },
    switchToNew() {
      window.location.href = NEW_VERSION_URL;
    }
  },
  created() {
    if (localStorage.getItem(HIDDEN_KEY) === "hidden") {
      this.showPopup = false;
    }
  }
};
</script>

<style scoped lang="scss">
// Header mặc định của el-dialog rỗng nhưng vẫn chiếm ~50px -> bỏ hẳn, chỉ giữ nút đóng ở góc.
::v-deep .ovd-dialog {
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header {
    padding: 0;
    height: 0;
  }
  // Span title rỗng vẫn tạo line box cao 24px -> phải ẩn hẳn, chỉ set padding là chưa đủ.
  .el-dialog__title {
    display: none;
  }
  // Nút đóng position:absolute theo .el-dialog nên vẫn hiện dù header cao 0.
  .el-dialog__headerbtn {
    top: 14px;
    right: 14px;
    font-size: 18px;
    z-index: 1;
  }
  .el-dialog__body {
    padding: 22px 24px 0;
    color: #1f2329;
  }
}

.ovd-head {
  display: flex;
  align-items: center;
}
.ovd-icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  margin-right: 10px;
  border-radius: 50%;
  background: #fdf6ec;
  color: #e6a23c;
  font-size: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ovd-title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.3;
}
.ovd-text {
  margin: 16px 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: #4e5969;
}
.ovd-deadline {
  display: flex;
  align-items: center;
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 6px;
  border-left: 3px solid #c8372d;
  background: #fef0f0;
  color: #c8372d;
  font-size: 14px;

  i {
    margin-right: 8px;
    font-size: 16px;
  }
  strong {
    font-weight: 600;
  }
}
.ovd-note {
  margin: 12px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #86909c;
}
.ovd-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px -24px 0;
  padding: 14px 24px;
  border-top: 1px solid #f0f0f0;
}
.ovd-actions {
  flex-shrink: 0;
}
</style>
